module.exports = __webpack_public_path__ + "img/img18.1dc4d805.png";